import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './styles/GlobalStyle';
import future from './styles/themes/future';
import ProgramShortcut from './components/game-interface/ProgramShortcut';
import Program from './components/game-interface/Program';
import { Layout } from './components/layout/styles-components';
import { GameInterfaceProvider } from './providers/GameInterfaceProvider';
import { GameSettingProvider } from './providers/GameSettingProvider';
import { YsdkProvider } from './yandex-add/YsdkProvider';

const App = () => {
	return (
		<YsdkProvider>
			<ThemeProvider theme={future}>
				<GlobalStyle/>
				<Layout>
					<GameInterfaceProvider>
						<GameSettingProvider>
							<ProgramShortcut/>
							<Program/>
						</GameSettingProvider>
					</GameInterfaceProvider>
				</Layout>
			</ThemeProvider>
		</YsdkProvider>
	);
};

export default App;
